import { createFileRoute } from '@tanstack/react-router'
import ProductionPlans from 'Administration/components/configuration/productionPlans/ProductionPlans'

import AdministrationPage from '../-administrationPage'
import { Guard } from '../-guard'

export const Route = createFileRoute('/administration/production-plans')({
    component: () => (
        <Guard claims={['opus_user']}>
            <AdministrationPage>
                <ProductionPlans />
            </AdministrationPage>
        </Guard>
    ),
})
